import {FC, useContext} from "react";
import {useTranslation} from "react-i18next";
import {I18Context, Languages, LanguagesType} from "../../i18nProvider";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import LanguageIcon from '@mui/icons-material/Language';
import {Box} from "@mui/system";

export const I18Picker: FC = () => {
    const { changeLanguage, i18n } = useContext(I18Context);
    const { t } = useTranslation();

    return (
      <FormControl size="small" sx={{minWidth: 150}}>
        <InputLabel id="language-label">
            <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'} gap={1}>
                <LanguageIcon fontSize={"small"}/>
                {t('language')}
            </Box>
            </InputLabel>
        <Select
          labelId="language-label"
          id="user-language"
          value={i18n.language}
          onChange={(e) => changeLanguage(e.target.value as LanguagesType)}
        >
          {Languages.map( language => (
            <MenuItem key={language} value={language}>
                <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'} gap={2}>
                    <LanguageIcon fontSize={"small"}/>
                    {t("user."+language)}
                    </Box>
            </MenuItem>
            ))}

        </Select>
      </FormControl>

    )
}